import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import LargeItemStatus from "../../../../../../common/components/large_item_status";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dataUtils from "../../../../../../common/utils/dataUtils";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
  onActionViewItem: (id: number | null, openState: boolean) => void;
  onActionRemoverChecklist: (id: number | null, openState: boolean) => void;
  onActionCopiar: (id: number | null, openState: boolean) => void,
};

export const GenerateProjetoDisciplinasColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionViewItem,
  onActionRemoverChecklist,
  onActionCopiar
}: Props): GridColDef[] => {

  const computeStatusColor = (status: string): "red" | "blue" | "yellow" | "green" | "gray" => {
    switch (status) {
      case "EA":
        return "yellow"; // Em andamento
      case "AT":
        return "red"; // Atrasada
      case "CD":
        return "green"; // Concluído no prazo
      case "CA":
        return "blue"; // Concluído com atraso
      case "NI":
        return "gray"; // Não iniciado
      case "NA":
        return "gray"; // Data não informada
      default:
        return "gray";
    }
  };

  const computeStatusDescription = (status: string) => {
    switch (status) {
      case "EA":
        return "Em Andamento";
      case "AT":
        return "Atrasada";
      case "CD":
        return "Concluído Dentro do Prazo";
      case "CA":
        return "Concluído Com Atraso";
      case "NI":
        return "Não Foi Iniciado";
      case "NA":
        return "Data Não Informada";
      default:
        return "?";
    }
  };

  const computeAnaliseDescription = (analise: string) => {
    switch (analise) {
      case "EA":
        return "Em Andamento";
      case "E":
        return "Encerrada";
      default:
        return "Não Informado";
    }
  };


  const computeAnaliseColor = (analise: string): "red" | "blue" | "yellow" | "green" | "gray" => {
    switch (analise) {
      case "EA": // Análise em andamento
        return "yellow";
      case "E": // Análise encerrada
        return "green";
      default:
        return "gray";
    }
  };

  return [
    {
      field: "Status",
      headerName: "Status",
      minWidth: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={params.value}
            color={computeStatusColor(params.value)}
            description={computeStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "Analise",
      headerName: "Análise",
      minWidth: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={params.value || "NA"}
            color={computeAnaliseColor(params.value)}
            description={computeAnaliseDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "Plantas",
      headerName: "Prancha",
      minWidth: 120,
      sortable: false,
    },
    {
      field: "Revisao",
      headerName: "Revisão",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "DataDisciplina",
      headerName: "Data",
      minWidth: 100,
      sortable: false,
      valueGetter: (params) => dataUtils.dataFormatada(params),
    },
    {
      field: "IdDisciplina",
      headerName: "Ações",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionCopiar(params.value, true)}>
            <DynamicIcon nameIcon="ContentCopyRounded" size={22} className="dark:text-white text-gray-500" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
    {
      field: "Checklist",
      headerName: "Checklist",
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 150,
      width: 150,
      renderCell: (params) => {
        const checklistTexto = params.row.Checklist as string | null;
        const checklistId = params.row.IdDisciplinaChecklist as number | null;

        if (!checklistTexto) return null;

        return (
          <div className="flex items-center justify-between w-full h-full">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onActionViewItem(checklistId, true);
                } else {
                  onActionViewItem(checklistId, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                px: ".4rem",
                py: 0,
                background: "#e6e6e6",
                borderLeft: ".2rem solid #8e44ad",
                borderRadius: 0,
                color: "black",
              }}
            >
              {checklistTexto}
            </Button>

            <IconButton onClick={() => onActionRemoverChecklist(checklistId, true)}>
              <DynamicIcon nameIcon="ClearRounded" size={20} className="text-red-500" />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
